import { useEffect } from "react";

function useKey(key, action) {
  useEffect(
    function () {
      function callback(e) {
        if (e.code.toLowerCase() === key.toLowerCase()) {
          action();
        }
      }
      document.addEventListener("keydown", callback);

      return function () {
        // clean up
        document.removeEventListener("keydown", callback);
      };
    },
    [action, key],
  );
}

export default useKey;
